import React from "react";

export const connectToast = (messageStore) => (Component) => {
  return class extends React.Component{
    state = {
      messages: []
    };

    constructor(props) {
      super(props);
      this.updateMessages = this.updateMessages.bind(this);
    }

    updateMessages(){
      this.setState({
        messages: [...messageStore.messages]
      })
    }

    componentDidMount(){
      messageStore.subscribe(this.updateMessages)
    }

    componentWillUnmount(){
      messageStore.unSubscribe(this.updateMessages);
    }

    render() {
      const {messages} = this.state;
      return <Component {...this.props} messages={messages}/>
    }
  }
};
